import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import WapiService from 'wanderu-service-wapi';

import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';
import { actions as stationsDataActions } from '../../appstate';

const logger = Logger.getLogger('wanderu-ducks-trips:fetchStationDetails');

function fetch(stationId) {
    return async (dispatch, getState) => {
        if (!stationId) {
            return;
        }

        const hasFetched = selectors.selectSuccess(getState(), stationId);
        const isFetching = selectors.selectWorking(getState(), stationId);
        if (hasFetched || isFetching) {
            return;
        }

        dispatch(actions.startWork(stationId));

        let error;
        try {
            const response = await WapiService.getStationDetails(stationId);

            if (response.result) {
                dispatch(stationsDataActions.setStationDetails(
                    stationId,
                    response.result,
                ));
            }
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(stationId, undefined, error));
        }
    };
}

const fetchStationDetailsAction = {
    fetch,
    ...selectors,
};

export {
    fetchStationDetailsAction,
};

export default {
    [namespace]: reducer,
};
